import { ZRoutingGraph, } from "../schemas/routingGraph.schema";
import { z } from "zod";
import { buildEarthingGrid } from "./algo";
export const ZEarthingPoint2d = z.tuple([z.number(), z.number()]);
export const ZApparatusFoundationForEarthingCalculation = z.object({
    id: z.string().min(1),
    points: z.array(ZEarthingPoint2d),
});
export const ZCalculateEarthingInput = z.object({
    apparatusFoundations: z.array(ZApparatusFoundationForEarthingCalculation),
});
export const ZCalculateEarthingOutput = ZRoutingGraph;
export const calculateEarthing = (input) => {
    const { nodes, edges } = buildEarthingGrid(input.apparatusFoundations);
    return ZRoutingGraph.parse({
        projectNo: 123456,
        systemCode: "EARTHING",
        systemName: "Earthing",
        floorName: "EARTHING",
        nodes,
        edges,
    });
};
